export default "__VITE_ASSET__TH6eXWA6__"